<div class="frequency-container" [ngClass]="{ 'align-start': align.toLowerCase() === 'start' }">
  <div
    [ngClass]="{
      'frequency-price': !allowCustomStyling,
      'large-frequency-price': size.toLowerCase() === 'large'
    }"
  >
    {{ value }}
  </div>
  <div class="frequency-value">
    <span *ngIf="!!currencyCode">&nbsp;{{ currencyCode }}</span>
    <span *ngIf="form.toLowerCase() === Form.VERBOSE">&nbsp;</span>
    <span>{{ frequency | glxyFrequency : form | translate }}</span>
  </div>
</div>
